<script>
import maintenanceOverlay from '@shared/components/shared/maintenance.vue'
import { theme } from '@shared/composables/useGlobalConfig'
import { useServiceWorkerVersionWatcher } from '@shared/composables/useServiceWorkerVersionWatcher'
import { getPlatformFromUrl } from '@shared/composables/useWhitelabelService.js'
import { useConfig } from '@shared/stores/config.js'
import { useHead } from '@unhead/vue'
import { onMounted } from 'vue'

export default {
  name: 'App',

  components: {
    maintenanceOverlay
  },

  setup() {
    useHead({
      titleTemplate: (title) => (title ? `${title} | ADMIN` : 'ADMIN')
    })
    const initializeTheme = () => {
      const htmlElement = document.documentElement
      const currentTheme = useConfig().theme
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches

      if (currentTheme) {
        htmlElement.classList.toggle(theme.DARK, currentTheme === theme.DARK)
      } else if (systemPrefersDark) {
        htmlElement.classList.add(theme.DARK)
        useConfig().theme = theme.DARK
      } else {
        htmlElement.classList.add(theme.LIGHT)
        useConfig().theme = theme.LIGHT
      }
    }

    const updateFavicon = () => {
      const platformKey = getPlatformFromUrl()
      const faviconUrl = `/public/img/white-label/${platformKey}/favicon/icon-32x32.png`

      let link = document.querySelector("link[rel~='icon']")
      link = document.createElement('link')
      link.rel = 'icon'
      document.getElementsByTagName('head')[0].appendChild(link)
      link.href = faviconUrl
    }

    const { checkForNewVersion, checkIfUnderMaintenance, checkServerAvailability } =
      useServiceWorkerVersionWatcher()

    onMounted(async () => {
      initializeTheme()
      updateFavicon()

      checkForNewVersion()
      checkIfUnderMaintenance()
      checkServerAvailability()
      window.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          checkForNewVersion()
          checkIfUnderMaintenance()
          checkServerAvailability()
        }
      })
    })
  }
}
</script>

<template>
  <router-view />
  <maintenance-overlay />
</template>

<style lang="scss">
@import './assets/css/style.scss';
</style>
